import _export from '../internals/export.js';
import global$1 from '../internals/global.js';
import setToStringTag$1 from '../internals/set-to-string-tag.js';

var $ = _export;
var global = global$1;
var setToStringTag = setToStringTag$1;
$({
  global: true
}, {
  Reflect: {}
}); // Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag

setToStringTag(global.Reflect, 'Reflect', true);
